/**
 *  @class
 *  @function BrandsSwitcher
 */
if (!customElements.get('brands-switcher')) {

  const BRAND_SELECTION_STORAGE_KEY = 'BRAND_SELECTION_STORAGE_KEY';

  class BrandsSwitcher extends HTMLElement {
    constructor() {
      super();

      this.headerMenu = document.querySelector('#header full-menu');
      this.headerMenuMobile = document.querySelector('#mobile-menu');
      this.items = this.querySelectorAll('[data-brands-switcher-item]');
    }

    connectedCallback() {
      if (!this.items.length) {
        return;
      }
      
      this.getBrandSelection();
      if (!this.selectedBrand) { this.storeBrandSelection('default'); }
      this.configureSwitcher();
      this.configureHeaderMenu();

      this.items.forEach((item) => {
        item.addEventListener('mousedown', this.onBrandSelect.bind(this)); 
      });
    }

    configureSwitcher() {
      if (!this.selectedBrand) return;

      const target = this.querySelector(`[data-brands-switcher-item="${this.selectedBrand}"]`);
      this.items.forEach((item) => { item.classList.remove('is-active'); })
      if (target) { target.classList.add('is-active'); }
    }

    configureHeaderMenu() {
      if (!this.selectedBrand) return;

      fetch(`${window.theme.routes.root_url}?section_id=api-brands-header`)
        .then((res) => res.text())
        .then((res) => {
          const fresh = document.createElement("div");
          fresh.innerHTML = res;

          const desktopMenu = fresh.querySelector(`[data-brands-menu-for="${this.selectedBrand}"]`);
          const mobileMenu = fresh.querySelector(`[data-brands-mobile-menu-for="${this.selectedBrand}"]`);
          if (desktopMenu && mobileMenu) {
            this.headerMenu.innerHTML = desktopMenu.querySelector("full-menu").innerHTML;
            this.headerMenuMobile.innerHTML = mobileMenu.querySelector("#mobile-menu").innerHTML;
            
            document.dispatchEvent(new CustomEvent('header:changed', { bubbles: true }));
          }
        })
        .catch((err) => {
          console.log(err);
        })
    }

    onBrandSelect(evt) {
      const target = evt.currentTarget;
      const id = target.getAttribute('data-brands-switcher-item');
      if (id) this.storeBrandSelection(id);
    }

    getBrandSelection() {
      const storedBrandSelection = sessionStorage.getItem(BRAND_SELECTION_STORAGE_KEY);
      this.selectedBrand = storedBrandSelection ? JSON.parse(storedBrandSelection) : null;
    }

    storeBrandSelection(data) {
      const dataString = JSON.stringify(data);

      sessionStorage.setItem(BRAND_SELECTION_STORAGE_KEY, dataString);
      this.selectedBrand = data;
    }
  }
  customElements.define('brands-switcher', BrandsSwitcher);
}